// extracted by mini-css-extract-plugin
module.exports = {"Module":"Workplace_Module__8wa7J"};